import React from 'react';

import {Heading} from 'components/Heading';
import {CallToAction} from 'components/CallToAction';
import CodeTabs from './CodeTabs'
const LINKS = { libraries: '/libraries', documentation: '/docs' };
const TITLE = 'An infrastructure that speaks your language';
const DESCRIPTION = "Community built server-side SDK's for your preferred programming language";
const BUTTON_TEXT = 'Read Docs';
const SDK_BUTTON_TEXT = 'View SDKs';

const ITEMS = [
  {
    name: 'Node.js',
    language: 'javascript',
    code: `import { Icloudready } from '@icloudready/node';

const icloudready = new Icloudready(process.env.ICLOUDREADY_API_KEY);

await icloudready.trigger('<NOTIFICATION_TEMPLATE_TRIGGER_ID>',
  {
    to: {
      subscriberId: '<UNIQUE_SUBSCRIBER_IDENTIFIER>',
      email: 'john@doemail.com',
      firstName: 'John',
      lastName: 'Doe',
    },
    payload: {
      name: "Hello World",
      organization: {
        logo: 'https://happycorp.com/logo.png',
      },
    },
  }
);
  `,
  },
  {
    name: 'Ruby',
    language: 'ruby',
    code: `require 'icloudready';

client = Icloudready::Client.new('ICLOUDREADY_API_KEY')

body = {
  name: "<NOTIFICATION_TEMPLATE_TRIGGER_ID>",
  payload: {
    name: "Hello World",
    organization: {
      logo: "https://happycorp.com/logo.png",
    },
  },
  to: {
    firstName: "John",
    lastName: "Doe",
    email: "john@doemail.com",
    phone: "07983882199",
  },
}.to_json

client.trigger_event(body)
  `,
  },
  {
    name: 'Python',
    language: 'python',
    code: `from icloudready.api import EventApi

event_api = EventApi("https://api.icloudready.co/api/", "<ICLOUDREADY_API_KEY>")
event_api.trigger(
    name="<NOTIFICATION_TEMPLATE_TRIGGER_ID>",
    recipients="<YOUR_SUBSCRIBER_ID>",
    payload={
      'name': 'Hello World',
      'organization': {
        'logo': 'https://happycorp.com/logo.png'
      }
    },
)
  `,
  },
  {
    name: 'PHP',
    language: 'php',
    code: `use Icloudready\\SDK\\Icloudready;

$icloudready = new Icloudready(<ICLOUDREADY_API_KEY>);

$icloudready->triggerEvent([
  'name' => '<NOTIFICATION_TEMPLATE_TRIGGER_ID>',
  'payload' => [
    'name' => 'Hello World',
    'organization' => [
			'logo': 'https://happycorp.com/logo.png',
		],
  ],
  'to' => [
      'subscriberId' => '<UNIQUE_SUBSCRIBER_IDENTIFIER>',
      'phone' => '07983882186',
      'email' => 'john@doemail.com',
      'firstName' => 'John',
      'lastName'  => 'Doe',
  ]
]);
  `,
  },
  {
    name: 'KOTLIN',
    language: 'javascript',
    code: `import co.icloudready.Icloudready
import co.icloudready.extensions.subscribers
import co.icloudready.dto.request.TriggerEventRequest
import co.icloudready.dto.request.SubscriberRequest

fun main() {
    val icloudready = Icloudready(apiKey = "ICLOUDREADY_API_KEY")

    icloudready.trigger(TriggerEventRequest.Companion.invoke
        (
            name = "<NOTIFICATION_TEMPLATE_TRIGGER_ID>",
            to = SubscriberRequest(
                    subscriberId = "harry_potter"
                    firstName = "Harry",
                    lastName = "Potter",
                    phone = "97X98XX98X1",
                    email = "email@email.com",
                    loacal = "locale",
                    avatar = "avatar",
            ),
            payload = mapOf("name" to "Hello World")
        )
    )
}
  `,
  },
  {
    name: 'Curl',
    language: 'bash',
    code: `curl -X POST
    -H "Content-Type: application/json"
    -H "Authorization: ApiKey REPLACE_WITH_API_KEY"
    -d '{
      "name": "<NOTIFICATION_TEMPLATE_TRIGGER_ID>",
      "payload": {
        "name": "Hello World"
      },
      "to": {
        "subscriberId": "<UNIQUE_SUBSCRIBER_IDENTIFIER>",
        "email": "john@doemail.com",
        "firstName": "John",
        "lastName": "Doe",
      }
    }'
  `,
  },
  {
    name: 'Go',
    language: 'go',
    code: `import (
      "context"
      "fmt"
      icloudready "github.com/icloud-ready/go-icloudready/lib"
      "log"
    )

subscriberID := "<UNIQUE_SUBSCRIBER_IDENTIFIER>"
apiKey := "<ICLOUDREADY_API_KEY>"
eventId := "<NOTIFICATION_TEMPLATE_TRIGGER_ID>"

ctx := context.Background()
to := map[string]interface{}{
  "lastName":     "Doe",
  "firstName":    "John",
  "subscriberId": subscriberID,
  "email":        "john@doemail.com",
}

payload := map[string]interface{}{
  "name": "Hello World",
  "organization": map[string]interface{}{
    "logo": "https://happycorp.com/logo.png",
  },
}

data := icloudready.ITriggerPayloadOptions{To: to, Payload: payload}
icloudreadyClient := icloudready.NewAPIClient(apiKey, &icloudready.Config{})

resp, err := icloudreadyClient.EventApi.Trigger(ctx, eventId, data)
if err != nil {
  log.Fatal("icloudready error", err.Error())
  return
}

fmt.Println(resp)
  `,
  },
];

  export default function Languages({ allLanguages, googleImages })  {
    const { title,  img, subtitle,features, style='',enable } = allLanguages
       if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    const googleImage = img && googleImages && googleImages[0] && googleImages[0].filter((image) => { if (image.name == img) return image })[0]
    const googleImage2 = img && googleImages && googleImages[1] && googleImages[1].filter((image) => { if (image.name == img) return image })[0]
    const gatsbyImage = googleImage && getImage(googleImage)
    const gatsbyImage2 = googleImage2 && getImage(googleImage2)
    return (
  <section className="languages safe-paddings bg-gray-2 pt-30 pb-40 lg:pt-24 lg:pb-32 md:pt-18 md:pb-28 sm:pt-12 sm:pb-18">
    <div className="container lg:grid lg:grid-cols-12  xl:gap-x-10 lg:gap-x-7 md:gap-x-5 lg:items-center flex flex-col">
      <div className="lg:col-start-1 lg:col-end-8 w-full lg:order-1 order-2 lg:mt-12 mt-8">
      <CodeTabs
          className="min-h-[560px] lg:mx-auto lg:w-full lg:max-w-[944px] md:mx-auto md:min-h-[482px] md:max-w-[712px] sm:min-h-[458px]"
          items={ITEMS}
        />
      </div>

      <div className="lg:col-start-9 lg:col-end-13 xl:col-start-8 order-1 text-center">
        <Heading size="xl" tag="h2" className="leading-tight md:text-4xl sm:text-3xl" theme="white">
          {TITLE}
        </Heading>
        <p className="mt-5 text-lg font-book leading-snug text-red  md:mt-3 md:text-base">
          {DESCRIPTION}
        </p>
        <CallToAction className="mt-7 md:mt-6" size="sm" theme="gray-outline" to={LINKS.libraries}>
          {SDK_BUTTON_TEXT}
        </CallToAction>
        <CallToAction
          className="mt-7 ml-7 md:mt-6"
          size="sm"
          theme="gray-outline"
          to={LINKS.documentation}
        >
          {BUTTON_TEXT}
        </CallToAction>
      </div>
    </div>
  </section>
)};

